import app from "flarum/common/app";
import LoadingIndicator from "flarum/common/components/LoadingIndicator";
import Placeholder from "flarum/common/components/Placeholder";
import UserPage from 'flarum/forum/components/UserPage';

import type Client from "src/common/models/Client";
import type Record from "src/common/models/Record";

export default class AuthorizedPage extends UserPage {
  records: Record[] = [];
  loading = true;
  nomore = false;
  page = 0;

  oninit(vnode: any) {
    super.oninit(vnode);

    this.loadUser(m.route.param('username'));
    this.loadRecords();
  }

  loadRecords() {
    app.store.find('oauth-records', { page: this.page } as any).then(records => {
      this.records = this.records.concat(records as unknown as Record[]);
      this.loading = false;
      if (this.records.length < 10) {
        this.nomore = true;
      }
      m.redraw();
    });
  }

  loadMore() {
    this.loadRecords();
    this.page += 1
  }

  content() {
    if (this.records.length == 0) {
      return <Placeholder>{app.translator.trans('rhodes-island-oauth-center.forum.authorized.no_records')}</Placeholder>;
    }

    return (
      <div className="AuthorizedPage">
        <div className="AuthorizedRecords">
          {this.records.map(record =>
            {
              const client = record.attribute("client") as Client;
              return <li className="AuthorizedRecord">
                <h3>
                  {client.client_name}
                  <time>
                    {record.authorized_at().toLocaleString()}
                  </time>
                </h3>
                <p>{client.client_desc}</p>
                <hr />
              </li>
            }
          )}
        </div>
        {this.loading && <LoadingIndicator/>}
      </div>
    );
  }
}
